(function () {
  function normalizePerKnifeText(text) {
    return text.replace(/^\(|\)$/g, '').trim();
  }

  function resolveFormContext(section) {
    if (!section) return null;

    const rechargeForm = section.querySelector('recharge-form-v3');
    if (rechargeForm) {
      return {
        type: 'recharge',
        formRoot: rechargeForm,
        trigger: rechargeForm.querySelector('[data-sticky-atc-trigger], .knife-selection__btns'),
        mainAtc: rechargeForm.querySelector('#addtocart')
      };
    }

    const highlightedForm = section.querySelector('product-form[data-highlighted-product-sticky]');
    const highlightedProductForm = highlightedForm?.querySelector('form[data-format="highlighted-product-sticky"]');
    if (highlightedForm && highlightedProductForm) {
      return {
        type: 'highlighted-product',
        formRoot: highlightedForm,
        trigger: null,
        mainAtc: highlightedProductForm.querySelector('#addtocart')
      };
    }

    const productForm = section.querySelector('product-form');
    const productV2Form = productForm?.querySelector('form[data-format="product-page-v2"]');
    if (productForm && productV2Form) {
      return {
        type: 'product-v2',
        formRoot: productForm,
        trigger: productForm.querySelector('[data-sticky-atc-trigger]'),
        mainAtc: productForm.querySelector('#addtocart')
      };
    }

    return null;
  }

  class StickyAtcController {
    constructor(bar) {
      this.bar = bar;
      this.sectionId = bar.dataset.stickyAtcSection;
      this.section = document.querySelector(`[data-section-id="${this.sectionId}"]`)?.closest('section')
        || document.querySelector(`#shopify-section-${this.sectionId}`);
      this.context = resolveFormContext(this.section);
      this.formType = this.context?.type;
      this.formRoot = this.context?.formRoot;
      this.trigger = this.context?.trigger;
      this.mainAtc = this.context?.mainAtc;
      this.titleEl = bar.querySelector('[data-sticky-atc-title]');
      this.priceEl = bar.querySelector('[data-sticky-atc-price]');
      this.perKnifeEl = bar.querySelector('[data-sticky-atc-per-knife]');
      this.btnTextEl = bar.querySelector('[data-sticky-atc-btn-text]');
      this.btnPriceEl = bar.querySelector('[data-sticky-atc-btn-price]');
      this.qtyValueEl = bar.querySelector('[data-sticky-atc-qty-value]');
      this.submitBtn = bar.querySelector('[data-sticky-atc-submit]');
      this.qtyDecreaseBtn = bar.querySelector('[data-sticky-atc-qty-btn="decrease"]');
      this.qtyIncreaseBtn = bar.querySelector('[data-sticky-atc-qty-btn="increase"]');
      this.isLoading = false;
      this.addingLabel = (window.variantStrings?.adding || 'Adding...').toUpperCase();
      this.resolveScrollTrigger();
    }

    resolveScrollTrigger() {
      if (this.isPermanent) return;

      this.usesSectionEndTrigger = false;

      const sectionEndTrigger = this.section?.querySelector('[data-sticky-atc-section-end]');
      if (sectionEndTrigger) {
        this.trigger = this.getSectionEndObserverTarget(sectionEndTrigger);
        this.usesSectionEndTrigger = true;
        return;
      }

      if (this.bar.dataset.stickyAtcWaitForSectionEnd === 'true') {
        const pageSectionEndTrigger = document.querySelector('[data-sticky-atc-section-end]');
        if (pageSectionEndTrigger) {
          this.trigger = this.getSectionEndObserverTarget(pageSectionEndTrigger);
          this.usesSectionEndTrigger = true;
        }
      }
    }

    getSectionEndObserverTarget(sectionEndTrigger) {
      return sectionEndTrigger.closest('[data-section-id]')
        || sectionEndTrigger.closest('.custom-order-sec-v2')
        || sectionEndTrigger.closest('section')
        || this.section;
    }

    shouldShowBar(entry) {
      if (this.usesSectionEndTrigger) {
        return entry.boundingClientRect.bottom <= 0;
      }
      return !entry.isIntersecting && entry.boundingClientRect.top < 0;
    }

    get isPermanent() {
      return this.bar.dataset.stickyAtcPermanent === 'true';
    }

    get isReady() {
      if (this.isPermanent) {
        return Boolean(this.formRoot && this.mainAtc);
      }
      return Boolean(this.formRoot && this.trigger && this.mainAtc);
    }

    getPriceElement() {
      if (this.formType === 'recharge') {
        return this.formRoot.querySelector('.current-variant-price-atc');
      }
      return this.formRoot.querySelector('[data-atc-total-price]');
    }

    getPerKnifeElement() {
      if (this.formType === 'recharge') {
        return this.formRoot.querySelector('.current-variant-per-knife');
      }
      return this.section?.querySelector('[data-preKnife]');
    }

    getQtyScope() {
      if (this.formType === 'recharge') {
        return this.formRoot.querySelector('.main-product-quantity-wrapper');
      }
      return this.formRoot.querySelector('[data-sticky-atc-trigger]')
        || this.formRoot.querySelector('.product-v2-atc-row');
    }

    getQtyInput() {
      if (this.formType === 'recharge') {
        return this.formRoot.querySelector('.main-product-quantity-wrapper [data-qty-input]');
      }
      const qtyScope = this.getQtyScope();
      return qtyScope?.querySelector('[data-qty-input]')
        || this.formRoot.querySelector('[data-qty-container] [data-qty-input]');
    }

    getQtyButton(action) {
      if (this.formType === 'recharge') {
        return this.formRoot.querySelector(`.main-product-quantity-wrapper [data-for="${action}"]`);
      }
      const qtyScope = this.getQtyScope();
      return qtyScope?.querySelector(`[data-for="${action}"]`)
        || this.formRoot.querySelector(`[data-qty-container] [data-for="${action}"]`);
    }

    hasQuantityBoxes() {
      return Boolean(this.formRoot?.querySelector('.main-product-quantity-boxes .box-item'));
    }

    getRechargeQuantities() {
      const wrapper = this.formRoot?.querySelector('.knife-selection__wrapper');
      if (!wrapper?.dataset.quantities) return [];
      return wrapper.dataset.quantities.split(',').map((qty) => parseInt(qty.trim(), 10)).filter(Boolean);
    }

    getActiveQuantityBox() {
      return this.formRoot?.querySelector('.main-product-quantity-boxes .box-item.active');
    }

    getDisplayedQuantity() {
      if (this.formType === 'recharge' && this.hasQuantityBoxes()) {
        const activeBox = this.getActiveQuantityBox();
        if (activeBox?.dataset.boxNumber) {
          return activeBox.dataset.boxNumber;
        }
      }
      return this.getQtyInput()?.value || '1';
    }

    selectQuantityBox(boxNumber) {
      const box = this.formRoot?.querySelector(
        `.main-product-quantity-boxes .box-item[data-box-number="${boxNumber}"]`
      );
      if (!box) return false;
      box.click();
      return true;
    }

    adjustRechargeQuantity(action) {
      if (!this.hasQuantityBoxes()) {
        const mainBtn = this.getQtyButton(action);
        if (mainBtn && !mainBtn.classList.contains('disabled')) {
          mainBtn.click();
        }
        return;
      }

      const quantities = this.getRechargeQuantities();
      const currentQty = parseInt(this.getDisplayedQuantity(), 10);
      const currentIndex = quantities.indexOf(currentQty);
      if (currentIndex === -1) return;

      const nextIndex = action === 'decrease' ? currentIndex - 1 : currentIndex + 1;
      if (nextIndex < 0 || nextIndex >= quantities.length) return;

      this.selectQuantityBox(quantities[nextIndex]);
    }

    init() {
      if (!this.isReady) return;

      // Keep sticky controls at the end of the document tab order so keyboard
      // users reach Learn More → quantity → ATC after page content, not mid-page.
      if (this.bar.parentElement !== document.body) {
        document.body.appendChild(this.bar);
      }

      this.sync();
      this.bindEvents();
      this.bindQtyInputSync();
      if (this.isPermanent) {
        this.setVisible(true);
      } else {
        this.setVisible(false);
        this.observeTrigger();
      }
      this.observeFormUpdates();
      this.observeMainAtcLoading();
    }

    setLoadingState(isLoading) {
      this.isLoading = isLoading;

      if (!this.submitBtn) return;

      if (isLoading) {
        const currentWidth = this.submitBtn.offsetWidth;
        if (currentWidth > 0) {
          this.submitBtn.style.setProperty('--sticky-atc-btn-width', `${currentWidth}px`);
        }
        this.submitBtn.classList.add('sticky-atc-bar__btn--loading');
        this.submitBtn.disabled = true;
        if (this.btnTextEl) {
          this.btnTextEl.textContent = this.addingLabel;
        }
        if (this.btnPriceEl) {
          this.btnPriceEl.textContent = '';
        }
        return;
      }

      this.submitBtn.classList.remove('sticky-atc-bar__btn--loading');
      this.submitBtn.style.removeProperty('--sticky-atc-btn-width');
      this.sync();
    }

    observeMainAtcLoading() {
      if (!this.mainAtc) return;

      const observer = new MutationObserver(() => {
        const isMainLoading = this.mainAtc.classList.contains('loading');
        if (isMainLoading !== this.isLoading) {
          this.setLoadingState(isMainLoading);
        }
      });

      observer.observe(this.mainAtc, {
        attributes: true,
        attributeFilter: ['class', 'disabled']
      });
    }

    showBar() {
      this.setVisible(true);
    }

    setVisible(isVisible) {
      this.bar.classList.toggle('sticky-atc-bar--visible', isVisible);
      this.bar.toggleAttribute('hidden', !isVisible);
      this.bar.toggleAttribute('inert', !isVisible);
      document.body.classList.toggle('sticky-atc-bar-active', isVisible);

      // If focus was inside the bar when it hides, return it to the document
      // so keyboard users are not trapped on an inert/hidden control.
      if (!isVisible && this.bar.contains(document.activeElement)) {
        document.activeElement.blur();
      }
    }

    bindEvents() {
      this.submitBtn?.addEventListener('click', () => {
        if (this.mainAtc.disabled || this.isLoading) return;
        this.setLoadingState(true);
        this.mainAtc.click();
      });

      this.qtyDecreaseBtn?.addEventListener('click', () => {
        if (this.qtyDecreaseBtn.disabled) return;
        if (this.formType === 'recharge') {
          this.adjustRechargeQuantity('decrease');
        } else {
          const mainBtn = this.getQtyButton('decrease');
          if (mainBtn && !mainBtn.classList.contains('disabled')) {
            mainBtn.click();
          }
        }
        window.requestAnimationFrame(() => this.sync());
      });

      this.qtyIncreaseBtn?.addEventListener('click', () => {
        if (this.qtyIncreaseBtn.disabled) return;
        if (this.formType === 'recharge') {
          this.adjustRechargeQuantity('increase');
        } else {
          const mainBtn = this.getQtyButton('increase');
          if (mainBtn && !mainBtn.classList.contains('disabled')) {
            mainBtn.click();
          }
        }
        window.requestAnimationFrame(() => this.sync());
      });
    }

    bindQtyInputSync() {
      const qtyInput = this.getQtyInput();
      if (!qtyInput) return;

      const scheduleSync = () => window.requestAnimationFrame(() => this.sync());
      qtyInput.addEventListener('input', scheduleSync);
      qtyInput.addEventListener('change', scheduleSync);
    }

    observeTrigger() {
      const updateVisibility = (entry) => {
        this.setVisible(this.shouldShowBar(entry));
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => updateVisibility(entry));
      }, { threshold: 0 });

      observer.observe(this.trigger);
    }

    observeFormUpdates() {
      const watchedSelectors = this.formType === 'recharge'
        ? [
            '.current-variant-price-atc',
            '.current-variant-per-knife',
            '.main-product-quantity-wrapper [data-qty-input]',
            '#addtocart'
          ]
        : [
            '[data-atc-total-price]',
            '[data-preKnife]',
            '[data-qty-input]',
            '#addtocart'
          ];

      const productFormTypes = ['product-v2', 'highlighted-product'];

      const observer = new MutationObserver(() => this.sync());
      watchedSelectors.forEach((selector) => {
        const scope = selector === '[data-preKnife]' ? this.section : this.formRoot;
        const el = scope?.querySelector(selector);
        if (!el) return;
        observer.observe(el, {
          attributes: true,
          attributeFilter: ['disabled', 'value'],
          childList: true,
          characterData: true,
          subtree: true
        });
      });

      if (this.formType === 'recharge') {
        this.formRoot.querySelectorAll('.main-product-quantity-boxes .box-item').forEach((box) => {
          box.addEventListener('click', () => window.requestAnimationFrame(() => this.sync()));
          observer.observe(box, {
            attributes: true,
            attributeFilter: ['class']
          });
        });

        this.formRoot.querySelectorAll('[name="radios-v2"], [name="radios-v3"]').forEach((radio) => {
          radio.addEventListener('change', () => window.requestAnimationFrame(() => this.sync()));
        });
      }

      if (productFormTypes.includes(this.formType)) {
        this.formRoot.querySelectorAll('[data-qty-btn]').forEach((btn) => {
          btn.addEventListener('click', () => window.requestAnimationFrame(() => this.sync()));
        });

        this.formRoot.querySelectorAll('input[type="radio"]').forEach((radio) => {
          radio.addEventListener('change', () => window.requestAnimationFrame(() => this.sync()));
        });
      }
    }

    sync() {
      const priceAtc = this.getPriceElement();
      const perKnife = this.getPerKnifeElement();
      const qtyInput = this.getQtyInput();
      const addText = this.mainAtc.querySelector('.add-text');
      const defaultBtnLabel = this.btnTextEl?.dataset.defaultLabel || '';
      const soldOutLabel = this.mainAtc.getAttribute('data-sold-out-label')
        || addText?.textContent?.trim()
        || defaultBtnLabel;

      const priceText = priceAtc?.textContent?.trim() || '';
      const perKnifeText = normalizePerKnifeText(perKnife?.textContent || '');
      const isSoldOut = this.mainAtc.disabled;

      if (this.priceEl) {
        this.priceEl.textContent = priceText;
      }

      if (this.perKnifeEl) {
        if (perKnifeText) {
          this.perKnifeEl.textContent = perKnifeText;
          this.perKnifeEl.hidden = false;
        } else {
          this.perKnifeEl.textContent = '';
          this.perKnifeEl.hidden = true;
        }
      }

      if (!this.isLoading) {
        if (this.btnTextEl) {
          this.btnTextEl.textContent = isSoldOut ? soldOutLabel : defaultBtnLabel;
        }

        if (this.btnPriceEl) {
          this.btnPriceEl.textContent = !isSoldOut && priceText ? ` – ${priceText}` : '';
        }
      }

      if (this.qtyValueEl) {
        this.qtyValueEl.textContent = this.getDisplayedQuantity();
      }

      if (this.submitBtn) {
        this.submitBtn.disabled = this.isLoading || this.mainAtc.disabled;
      }

      if (this.formType === 'recharge' && this.hasQuantityBoxes()) {
        const quantities = this.getRechargeQuantities();
        const currentQty = parseInt(this.getDisplayedQuantity(), 10);
        const currentIndex = quantities.indexOf(currentQty);
        if (this.qtyDecreaseBtn) {
          this.qtyDecreaseBtn.disabled = currentIndex <= 0;
        }
        if (this.qtyIncreaseBtn) {
          this.qtyIncreaseBtn.disabled = currentIndex === -1 || currentIndex >= quantities.length - 1;
        }
      } else {
        const mainDecrease = this.getQtyButton('decrease');
        const mainIncrease = this.getQtyButton('increase');
        if (this.qtyDecreaseBtn) {
          this.qtyDecreaseBtn.disabled = mainDecrease?.classList.contains('disabled') ?? false;
        }
        if (this.qtyIncreaseBtn) {
          this.qtyIncreaseBtn.disabled = mainIncrease?.classList.contains('disabled') ?? false;
        }
      }
    }
  }

  function initStickyAtc() {
    document.querySelectorAll('[data-sticky-atc]').forEach((bar) => {
      if (bar.dataset.stickyAtcInitialized === 'true') return;
      const controller = new StickyAtcController(bar);
      if (!controller.isReady) return;
      if (controller.btnTextEl && !controller.btnTextEl.dataset.defaultLabel) {
        controller.btnTextEl.dataset.defaultLabel = controller.btnTextEl.textContent.trim();
      }
      controller.init();
      bar.dataset.stickyAtcInitialized = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAtc);
  } else {
    initStickyAtc();
  }

  document.addEventListener('shopify:section:load', initStickyAtc);
})();
